import { render, staticRenderFns } from "./FavouritesView.vue?vue&type=template&id=0ca9eb7b"
import script from "./FavouritesView.vue?vue&type=script&lang=js"
export * from "./FavouritesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports